import _extends from '@babel/runtime-corejs3/helpers/extends';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import React__default from 'react';
import classNames from 'classnames';
import styles from './3a45c54293a4f241b4f8c8b3a863cd45fe05872a00d72d2872bb6f70906d8e71.cfe-internal.js';
import { useFormFieldLabel } from '../FormField/ff8bdfb918b98e400d01f1272050447aed13a9c7dbe824884d42b110edddae42.cfe-internal.js';

var _excluded = ["children", "className"];
var Label = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var _classNames;

  var children = _ref.children,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useFormFieldLabel = useFormFieldLabel(),
      isFocused = _useFormFieldLabel.isFocused,
      hasControl = _useFormFieldLabel.hasControl;

  var classes = classNames(styles.label, className, (_classNames = {}, _defineProperty(_classNames, styles.control, hasControl), _defineProperty(_classNames, styles.focused, isFocused), _classNames));
  return /*#__PURE__*/React__default.createElement("label", _extends({}, rest, {
    ref: ref,
    className: classes
  }), children);
});
var Label$1 = Label;

export { Label$1 as default };
